export default __webpack_public_path__ + "static/media/add-lekalo-icon.cfadeec7.svg";